export const APPROVED = "PageApproved";
export const DECLINED = "PageDeclined";
export const DOCUMENT_CAPTURE_PORTRAIT = "PageDocumentCapturePortrait";
export const DOCUMENT_CAPTURE_LANDSCAPE = "PageDocumentCaptureLandscape";
export const DOCUMENT_CAPTURE_LOCK = "PageDocumentCaptureLock";
export const DOCUMENT_CAPTURE_CONFIRM = "PageDocumentCaptureConfirm";
export const DOCUMENT_CAPTURE_INSTRUCTIONS = "PageDocumentCaptureInstructions";
export const FACE_CAPTURE = "PageFaceCapture";
export const FACE_CAPTURE_CONFIRM = "PageFaceCaptureConfirm";
export const FACE_CAPTURE_INSTRUCTIONS = "PageFaceCaptureInstructions";
export const LIVENESS_TEST = "PageLivenessTest";
export const LIVENESS_TEST_RETRY = "PageLivenessTestRetry";
export const REVIEWING = "PageReviewing";
export const THANK_YOU = "PageThankYou";
export const VALIDATE_PHONE = "PageValidatePhone";
export const VERIFICATION_CODE = "PageVerificationCode";
export const VERIFY_IDENTITY = "PageVerifyIdentity";
export const SENT_TO_MOBILE = "PageSentToMobile";
export const FACE_LIVENESS_3D = "PageFaceLiveness3D";
export const INSTRUCTIONS_FACE_LIVENESS_3D = "PageInstructionsFaceLiveness3D";
export const INSTRUCTION_VIDEO_FACE_LIVENESS_3D = "PageInstructionVideo3DFL";
export const INSTRUCTION_VIDEO_DOCUMENT = "PageInstructionVideoDocument";
export const INSTRUCTION_VIDEO_SELFIE = "PageInstructionVideoSelfie";
export const DOCUMENT_COUNTRY_SELECTOR = "PageDocumentCountrySelector";
export const INTRO_PAGE = "PageIntroScreen";

export const INSTRUCTIONS_CLR = "PageInstructionsCLR";

export const GDPR = "PageGDPR";
